import React from "react";
import PastorDashboard from "../pastors/pastor-dashboard/PastorDashboard";
import IdleWrapper from "../components/auth/IdleWrapper";

export default function PastorDashboardPage() {
  return <IdleWrapper> <PastorDashboard /> </IdleWrapper>;
}
